import { isLoggedIn } from '@src/redux/modules/auth'
import * as qs from 'utils/querystring'

export default function requireAuth (store) {
  return (nextState, replace, next, finish) => {
    const globalState = store.getState()
    if (isLoggedIn(globalState)) {
      return next()
    }

    const {
      pathname,
      search
    } = nextState.location

    const nextQueryString = pathname + search
    const nextUrl = qs.stringify({ next: nextQueryString }, true)
    const url = `/signup${nextUrl}`
    replace(url)

    return next()
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/requireAuth.js